export default {"src":"/_next/static/media/import-financing.7921b74b.svg","height":33,"width":33};